<template>
  <layout-main-inner title="快检数据">
    <layout-card-wrap>
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick">
        <el-tab-pane
          label="未处理"
          name="1">
          <un-reported-table ref="table1" />
        </el-tab-pane>
        <el-tab-pane
          label="已处理"
          name="2">
          <reported-table ref="table2" />
        </el-tab-pane>
      </el-tabs>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import ReportedTable from './busi/reported-table.vue'
import UnReportedTable from './busi/un-reported-table.vue'

export default {
  name: 'InspectionData',
  components: { ReportedTable, UnReportedTable },
  data() {
    return {
      loading: true,
      activeName: '1',
      list: [],
      totalNum: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        statusList: [0]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  methods: {
    handleClick(tab) {
      this.$refs['table' + tab.name].handleCurrentChange(1)
    },
    generateinspectionreport() {
      this.loading = true
      this.$store.dispatch('account/generateinspectionreport', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus">
.tab-inner-form {
  display flex;
  align-items center;
  justify-content space-between;
  margin-bottom 15px
}
</style>
